// import tools from  "@/public/tools.js"
//臨時解決方案，先把雙語放本地，後續需要放後臺
export default { 
	//获取元素距离信息
	getElementOffset(state){
		return (key)=>{						
			return state.offsets[key];
		}
	},
	isLogin(state){
		return state.isLogin;
	},
	getNavList(state){
		return state.nav;
	},
	getLoginInfo(state){
		return state.loginInfo;
	},
	getTopData(state){
		return state.top;
	},
	getsalesData(state){
		return state.salesData||{}
	},
	getImglist(state){
		return state.imglist;
	},
	
	getLanguangeData(state){	
		return state.languageKey
		// return function(key){
		// 	key = key?(state.languageKey.prefix + key):state.languageKey.full;
		// 	let data = tools.getSlocal(key);			
		// 	return data;
		// };
	}
}